var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FlexGrid, Skeleton, Sticky, Styler, TypographyBody, TypographyHeading } from '@honeycomb/ui-core';
import React from 'react';
import { initialSearchParameters, useEstabOffers, useGetNearestAirports, useGlobalContext, useSearch, } from '@honeycomb/data';
import { searchCreatedRouting } from '@honeycomb/routing';
import { HotelOfferCard } from './HotelOfferCard';
import { getEstabOfferRequest } from '../../../utils/recentView';
import { addDay, toUTCDate } from '../../../utils/date-utils';
export function HotelOffers(_a) {
    var _b, _c;
    var { hotelName, estabId, isSticky, stickyContext } = _a, other = __rest(_a, ["hotelName", "estabId", "isSticky", "stickyContext"]);
    const { resourceStrings: { ESTAB_OFFER_LABEL }, configSettings: { DefaultEstabOfferDurationOffset, DefaultEstabOfferDuration, DefaultEstabOfferAirport, DefaultEstabOfferCount, HotelHolidayDefaultAdultsPerRoom, }, } = useGlobalContext();
    const inputDetails = {
        id: estabId,
        title: hotelName,
        legacyType: 1,
        destination: '',
        duration: DefaultEstabOfferDuration,
        durationOffset: parseInt(DefaultEstabOfferDurationOffset),
        airports: DefaultEstabOfferAirport,
        adults: HotelHolidayDefaultAdultsPerRoom,
        isCacheEnabled: true,
        isCached: true,
        searchParam: initialSearchParameters,
        isDestinationOrEstabPage: true,
    };
    const offerRequestDetails = getEstabOfferRequest(inputDetails);
    const { adults, duration, airportCodes: existingAirportCodes } = offerRequestDetails.estabOffersRequest;
    // check airport count and if its single airport then call nearest airport
    const skipNearestAirport = existingAirportCodes.length !== 1;
    const { airportCodes: newAirportCodes, loading: loadingNearestAirport } = useGetNearestAirports(existingAirportCodes[0], skipNearestAirport);
    const offerRequest = Object.assign(Object.assign({}, offerRequestDetails.estabOffersRequest), { airportCodes: newAirportCodes && newAirportCodes.length > 0 ? newAirportCodes : existingAirportCodes });
    const { data, loading: loadingEstabOffers } = useEstabOffers(offerRequest, undefined, loadingNearestAirport !== null && loadingNearestAirport !== void 0 ? loadingNearestAirport : false);
    const [_search, setSearch] = useSearch([searchCreatedRouting]);
    const { createSearch } = setSearch;
    const handleEstabSearch = (airportCode, date) => {
        const startDate = toUTCDate(new Date(date));
        const endDate = addDay(new Date(startDate), duration).toISOString().split('T')[0];
        const state = Object.assign(Object.assign({}, offerRequestDetails.searchParameter), { departureAirports: [airportCode], startDate,
            endDate });
        createSearch(state);
    };
    const waitingForOffers = loadingNearestAirport || loadingEstabOffers;
    const offers = (_b = data === null || data === void 0 ? void 0 : data.estabOffers) === null || _b === void 0 ? void 0 : _b.offers;
    const offersCount = parseInt(DefaultEstabOfferCount) || 4;
    const topOffers = (_c = offers === null || offers === void 0 ? void 0 : offers.filter((offer) => !!offer).slice(0, offersCount)) !== null && _c !== void 0 ? _c : [];
    // Return null if we are not waiting for offers and there are no valid topOffers
    if (!waitingForOffers && topOffers.length === 0) {
        return null;
    }
    return (React.createElement(Sticky, { context: stickyContext || undefined, disabled: !isSticky, zIndexOffset: -1 },
        React.createElement(Styler, Object.assign({ component: "section" }, other),
            React.createElement(TypographyHeading, { "data-id": "offers-heading-skeleton", component: waitingForOffers ? 'div' : 'h2', mb: 4 },
                waitingForOffers ? React.createElement(Skeleton, { variant: "text", w: "50%" }) : React.createElement("div", null, ESTAB_OFFER_LABEL),
                React.createElement(TypographyBody, { component: "div", size: "xl", transition: "inherit" }, waitingForOffers ? React.createElement(Skeleton, { variant: "text", w: "70%" }) : hotelName)),
            React.createElement(FlexGrid, { container: true, spacing: 5 }, waitingForOffers
                ? Array.from({ length: offersCount }, (_, index) => (React.createElement(FlexGrid, { xs: 12, m: 6, l: 12, key: index },
                    React.createElement(HotelOfferCard, { "data-id": "skeleton-offer-card" }))))
                : topOffers === null || topOffers === void 0 ? void 0 : topOffers.map((offer, index) => {
                    if (!offer.priceFormatted) {
                        return null;
                    }
                    const { airport, airportCode, date, boardType, priceFormatted } = offer;
                    return (React.createElement(FlexGrid, { xs: 12, m: 6, l: 12, key: `${estabId}-hotel-offer-${index}` },
                        React.createElement(HotelOfferCard, { key: `${estabId}-offer-${index}`, details: {
                                adults,
                                airportName: airport !== null && airport !== void 0 ? airport : '',
                                startDate: date !== null && date !== void 0 ? date : '',
                                duration,
                                boardType: boardType !== null && boardType !== void 0 ? boardType : '',
                                price: priceFormatted !== null && priceFormatted !== void 0 ? priceFormatted : undefined,
                            }, onClick: () => handleEstabSearch(airportCode !== null && airportCode !== void 0 ? airportCode : '', date !== null && date !== void 0 ? date : '') })));
                })))));
}
